import * as Types from '@/types/schema';

import gql from 'graphql-tag';
export type QuizLanguageInfoFragment = { id: string, type: Types.ResourceTypeEnum, status: Types.ResourceStatusEnum, lastContentEditTimeAt?: string | null, languageType?: Types.LanguageEnum | null, defaultLanguageType?: Types.LanguageEnum | null, isLocalizedContent: boolean, sourceContentSyncedAt?: string | null, languageConfigs?: Array<{ contentId: string, languageType: Types.LanguageEnum, jobStatus?: Types.JobEntityStatusEnum | null }> | null, sourceContent?: { id: string, lastContentEditTimeAt?: string | null, languageType?: Types.LanguageEnum | null, defaultLanguageType?: Types.LanguageEnum | null, languageConfigs?: Array<{ contentId: string, languageType: Types.LanguageEnum, jobStatus?: Types.JobEntityStatusEnum | null }> | null } | {} | null };


export type QuizLanguageInfoFragmentVariables = Types.Exact<{ [key: string]: never; }>;

export const QuizLanguageInfoFragmentDoc = /*#__PURE__*/ gql`
    fragment QuizLanguageInfo on QuizContentType {
  id
  type
  status
  lastContentEditTimeAt
  languageType
  languageConfigs {
    contentId
    languageType
    jobStatus
  }
  defaultLanguageType
  isLocalizedContent
  sourceContent {
    ... on QuizContentType {
      id
      lastContentEditTimeAt
      languageType
      languageConfigs {
        contentId
        languageType
        jobStatus
      }
      defaultLanguageType
    }
  }
  sourceContentSyncedAt
}
    `;